import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=36ead10b&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vincent/Documents/Développement/Stadia Fr/Jeux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ead10b')) {
      api.createRecord('36ead10b', component.options)
    } else {
      api.reload('36ead10b', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=36ead10b&", function () {
      api.rerender('36ead10b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/javascripts/components/Loader.vue"
export default component.exports